Array.prototype.unique = function (property) {
    var s = new Set();
    return this.filter(function (value, index, self) {
        var val = value;
        if (property) {
            val = property.split('.').reduce(function (p, c) { return p && p[c] || null; }, value);
        }
        if (property && s.has(val)) {
            return false;
        }
        else if (property) {
            s.add(val);
            return true;
        }
        if (s.has(value)) {
            return false;
        }
        s.add(value);
        return true;
    });
};
Array.prototype.chunk = function (size) {
    var R = new Array();
    for (var i = 0; i < this.length; i += size)
        R.push(this.slice(i, i + size));
    return R;
};
RegExp.escape = function (str, escaper) {
    if (escaper === void 0) { escaper = '\\'; }
    return str.replace(/[-\/\\^$*+?.()|[\]{}]/g, escaper + '$&');
};
Math.easeInOutQuad = function (t, b, c, d) {
    t /= d / 2;
    if (t < 1)
        return c / 2 * t * t + b;
    t--;
    return -c / 2 * (t * (t - 2) - 1) + b;
};
export function errorToString(err, defaultMessage) {
    if (defaultMessage === void 0) { defaultMessage = 'An unhandled error occurred. Please try again later.'; }
    if (err && err.type == 'NotVerifiedError') {
        return [];
    }
    else if (err && err.type == 'InvalidSubscriptionError') {
        return [];
    }
    else if (err && err.type == 'InvalidParametersError') {
        return Object.keys(err.invalid_keys).map(function (key) {
            return key + ': ' + err.invalid_keys[key];
        });
    }
    else if (err && err.type == 'ResourceAlreadyExists' || err && err.message) {
        return [err.message];
    }
    else {
        return [defaultMessage];
    }
}
export * from './components';
export * from './context';
export * from './pages';
export * from './player';
export * from './util/compare';
export * from './HOC';
export * from './assets';
export * from './util/compare';
export * from './util/date';
export { default as SideBar } from './layout/Sidebar';
export { default as Header } from './layout/Header';
export { setMessages } from './messages';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./bpm-web-generic/lib/index.js
// module id = 25
// module chunks = 0